const API_BASE = import.meta.env.VITE_API_URL;
const AUTHKIT_URL = import.meta.env.VITE_WORKOS_AUTHKIT_URL;

// Helper function to determine if we're in a preview deployment
function isPreviewDeployment() {
  const hostname = window.location.hostname;
  // Check if the URL matches the pattern of Cloudflare Pages preview deployments
  return hostname.includes(".pages.dev") && /^[a-z0-9]+\./.test(hostname);
}

// Get the appropriate redirect URI based on the current environment
function getRedirectUri() {
  if (isPreviewDeployment()) {
    // For preview deployments, use the current origin
    const origin = window.location.origin;
    return `${origin}/api/auth/callback`;
  }

  // For production/staging, use the configured API base
  return `${API_BASE}/api/auth/callback`;
}

export const WORKOS_CONFIG = {
  clientId: import.meta.env.VITE_WORKOS_CLIENT_ID,
  // Use the dynamic redirect URI
  get redirectUri() {
    return getRedirectUri();
  },
} as const;

export function getWorkOSAuthUrl() {
  const redirectUri = getRedirectUri();

  const params = new URLSearchParams({
    client_id: WORKOS_CONFIG.clientId,
    redirect_uri: redirectUri,
    response_type: "code",
  });

  // Add the redirect_uri as a separate parameter to be passed back to the server
  // This ensures the server knows which URI was used for the initial request
  if (isPreviewDeployment()) {
    params.append("state", JSON.stringify({ redirect_uri: redirectUri }));
  }

  return `${AUTHKIT_URL}?${params}`;
}
